import { isAtLeast } from '../utils/_breakpoints.js';
class mBacktotop extends HTMLDivElement {
    constructor() {
        super();
        this.offset = 100;
        this.oldValue = 0;
    }

    connectedCallback() {
        this.addEventListener('click', () => {
            this.scrollToTop();
        });

        if (isAtLeast('md')) {
            window.addEventListener('scroll', () => {
                this.toggleDesktopButton();
            });
        } else {
            window.addEventListener('scroll', () => {
                this.toggleMobileButton();
            });
        }
    }

    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    toggleDesktopButton() {
        if (document.body.scrollTop > this.offset || document.documentElement.scrollTop > this.offset) {
            this.setAttribute('aria-hidden', false);
            this.firstElementChild.tabIndex = 0;
        } else {
            this.setAttribute('aria-hidden', true);
            this.firstElementChild.tabIndex = -1;
        }
    }

    toggleMobileButton() {
        // Get the new Value
        var newValue = window.pageYOffset;

        // Subtract the two and conclude
        if (this.oldValue - newValue < 0 || newValue < this.offset) {
            this.setAttribute('aria-hidden', true);
            this.firstElementChild.tabIndex = -1;
        } else if (this.oldValue - newValue > 0) {
            this.setAttribute('aria-hidden', false);
            this.firstElementChild.tabIndex = 0;
        }

        // Update the old value
        this.oldValue = newValue;
    }
}

customElements.define('m-backtotop', mBacktotop, {
    extends: 'div'
});
